import { request } from './repository';

const url = 'messages/';
const createUrl = 'create-message/';
const sendUrl = 'send-message';

const messageRepository = {


    fetchMessages() {
        return request.get(url);
    },

    createMessage(payload) {
        return request.post(createUrl, payload);
    },

    sendMessage(id) {
        return request.get(`${sendUrl}/${id}`);
    },
};

export default messageRepository;